import React, { useEffect, useRef, useState } from "react";
import { getConsent } from "@/components/CookieBanner";

const ADSENSE_CLIENT = "ca-pub-7308366638702953";

export const AdBanner = ({ slot, format = "leaderboard", className = "" }) => {
  const insRef = useRef(null);
  const [consent, setConsentState] = useState(getConsent);
  const sizeCls = format === "rectangle"
    ? "min-h-[250px] max-w-[300px]"
    : "min-h-[100px] sm:min-h-[90px] max-w-[728px]";

  useEffect(() => {
    const onConsent = () => setConsentState(getConsent());
    window.addEventListener("rv-consent", onConsent);
    return () => window.removeEventListener("rv-consent", onConsent);
  }, []);

  useEffect(() => {
    if (consent !== "granted") return;
    const el = insRef.current;
    if (!el || el.getAttribute("data-adsbygoogle-status")) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense not loaded (blocker or dev environment): expected, log in dev only
      if (process.env.NODE_ENV === "development") console.debug("AdSense push skipped:", e);
    }
  }, [consent]);

  if (consent === "denied") return null;

  return (
    <div
      data-testid={`ad-banner-${slot}`}
      data-ad-slot={slot}
      className={`ad-slot w-full mx-auto ${sizeCls} ${className}`}
    >
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner;
